import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { summary } from './data/summary';
import useInView from '../hooks/useInView';

// Column widths per block (out of 12), alternating so two rows never look alike.
const WIDTHS = ['col-lg-5', 'col-lg-7', 'col-lg-7', 'col-lg-5'];

const Summary = () => {
  const [ref, inView] = useInView();

  return (
    <section
      id="summary"
      aria-labelledby="summary-title"
      ref={ref}
      className={`section summary reveal${inView ? ' in-view' : ''}`}
    >
      <div className="container">
        <h2 id="summary-title" className="section-title">
          Summary
        </h2>
        <div className="row g-4">
          {summary.map((item, index) => (
            <div className={`col-12 ${WIDTHS[index % WIDTHS.length]}`} key={item.id}>
              <div className="spec">
                <h3 className="spec-title">
                  <FontAwesomeIcon className="spec-icon" icon={item.icon} aria-hidden="true" />
                  {item.title}
                </h3>
                {item.display === 'tags' ? (
                  <ul className="tag-list">
                    {item.items.map((text) => (
                      <li className="tag" key={text}>
                        {text}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <ul className="spec-list">
                    {item.items.map((text) => (
                      <li key={text}>{text}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Summary;
